import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {IddTraining} from '../../../shared/interface/idd-training';
import {Observable, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {AuthService} from '../../../shared/services/auth.service';
import {IddTrainingService} from '../../../shared/services/idd-training.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {IDD_TRAINING_STATUS_NOT_APPLICABLE} from '../../../shared/services/dict.service';
import {ChartType} from '../idd-training-chart/idd-training-chart.component';
import {AddStatementDialogComponent} from '../add-statement-dialog/add-statement-dialog.component';
import {DocumentService} from '../../../shared/services/document.service';

@Component({
  selector: 'app-idd-training-details-view',
  templateUrl: './idd-training-details-view.component.html',
  styleUrls: ['./idd-training-details-view.component.scss']
})
export class IddTrainingDetailsViewComponent implements OnInit, OnDestroy {
  @Input() iddTraining: Observable<IddTraining>;
  @Output() changed: EventEmitter<any> = new EventEmitter<any>();

  readonly IDD_TRAINING_STATUS_NOT_APPLICABLE = IDD_TRAINING_STATUS_NOT_APPLICABLE;

  iddTrainingObject: IddTraining;
  userPermissions: ReplaySubject<UserPermissions>;
  chartType = ChartType.Horizontal;
  daysToEndOfYear = 0;
  hoursLeftAssets = 0;
  minutesLeftAssets = 0;
  hoursLeftLife = 0;
  minutesLeftLife = 0;
  hoursLeftGeneral = 0;
  minutesLeftGeneral = 0;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private authService: AuthService,
    private iddTrainingService: IddTrainingService,
    private snack: MatSnackBar,
    private dialog: MatDialog,
    private documentService: DocumentService,
  ) {
    this.userPermissions = authService.getUserPermissions();

    const today = new Date();
    const endOfYear = new Date(today.getFullYear(), 11, 31);
    const secondsInDay = 1000 * 60 * 60 * 24;

    this.daysToEndOfYear = Math.ceil((endOfYear.getTime() - today.getTime()) / (secondsInDay));
  }

  ngOnInit(): void {
    this.iddTraining
      .pipe(takeUntil(this.destroyed$))
      .subscribe((iddTraining: IddTraining) => {
        this.iddTrainingObject = iddTraining;

        this.hoursLeftAssets = Math.floor(Math.max(0, (iddTraining.requiredAssetsMinutes - iddTraining.realisedAssetsMinutes) / 60));
        this.minutesLeftAssets = Math.floor(Math.max(0, (iddTraining.requiredAssetsMinutes - iddTraining.realisedAssetsMinutes) % 60));
        this.hoursLeftLife = Math.floor(Math.max(0, (iddTraining.requiredLifeMinutes - iddTraining.realisedLifeMinutes) / 60));
        this.minutesLeftLife = Math.floor(Math.max(0, (iddTraining.requiredLifeMinutes - iddTraining.realisedLifeMinutes) % 60));
        this.hoursLeftGeneral = Math.floor(Math.max(0, (iddTraining.requiredGeneralMinutes - iddTraining.realisedGeneralMinutes) / 60));
        this.minutesLeftGeneral = Math.floor(Math.max(0, (iddTraining.requiredGeneralMinutes - iddTraining.realisedGeneralMinutes) % 60));
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  changeToNotApplicable(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz anulować?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.iddTrainingService.cancelIddTraining(this.iddTrainingObject.uuid)
          .subscribe(() => {
            this.snack.open('Szkolenie zostało oznaczone jako "Nie dotyczy"', '', {duration: 2000});
            this.changed.emit();
          });
      }
    });
  }

  addStatement(): void {
    const dialogRef = this.dialog.open(AddStatementDialogComponent, {
      width: '500px',
      data: {iddTrainingObject: this.iddTrainingObject},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.changed.emit();
      }
    });
  }


  refresh(): void{
    this.iddTrainingService.refreshIddTraining(this.iddTrainingObject.uuid)
      .subscribe(() => {
        this.snack.open('Wymogi zostały zaktualizowane', '', {duration: 2000});
        this.changed.emit();

      });
  }

  downloadZip(): void {
    this.iddTrainingService.downloadCertificates(this.iddTrainingObject.uuid);
  }

  floor(num: number): number {
    return Math.floor(num);
  }

  downloadStatement(): void {
    this.documentService.downloadFile(this.iddTrainingObject.statement.uuid);
  }

  deleteStatement(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć oświadczenie?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.documentService.deleteDocument(this.iddTrainingObject.statement.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto oświadczenie', '', {duration: 2000});
            this.changed.emit();
          });
      }
    });
  }
}
